/**
 * Branch carrier task definitions.
 * Re-exports all Branch-specific task definitions for use by BranchTaskSet.
 */
import type { TaskDefinition } from '../../../config/types';

import { signApplication } from './sign-application';
import { completeInventory } from './complete-inventory';
import {
  stressFreeSwitchHome,
  stressFreeSwitchAuto,
  stressFreeSwitchRenters,
  stressFreeSwitchUmbrella
} from './stress-free-switch';
import { reviewPotentialUndisclosedDriver } from './review-potential-undisclosed-driver';
import { connectedHomeRenewal } from './connected-home-renewal';
import { proofOfPriorCoverage } from './proof-of-prior-coverage';
import { proofOfGoodStudent } from './proof-of-good-student';
import { proofOfConnectedHome } from './proof-of-connected-home';
import { proofOfAccidentPrevention } from './proof-of-accident-prevention';
import { windstormMitigation } from './windstorm-mitigation';
import { scheduledPersonalProperty } from './scheduled-personal-property';
import { miPipOption4 } from './mi-pip-option4';
import { miPipOption5 } from './mi-pip-option5';
import { miPipOption6 } from './mi-pip-option6';
import { fortifiedHome } from './fortified-home';
import { communityDriveRegistration } from './community-drive-registration';
import { verifyRoofYear } from './verify-roof-year';

export const allBranchTaskDefinitions: TaskDefinition[] = [
  signApplication,
  completeInventory,
  stressFreeSwitchHome,
  stressFreeSwitchAuto,
  stressFreeSwitchRenters,
  stressFreeSwitchUmbrella,
  reviewPotentialUndisclosedDriver,
  connectedHomeRenewal,
  proofOfPriorCoverage,
  proofOfGoodStudent,
  proofOfConnectedHome,
  proofOfAccidentPrevention,
  windstormMitigation,
  scheduledPersonalProperty,
  miPipOption4,
  miPipOption5,
  miPipOption6,
  fortifiedHome,
  communityDriveRegistration,
  verifyRoofYear
];
